import { render, staticRenderFns } from "./SmsSummary.vue?vue&type=template&id=f57b36ee&scoped=true&"
import script from "./SmsSummary.vue?vue&type=script&lang=js&"
export * from "./SmsSummary.vue?vue&type=script&lang=js&"
import style0 from "./SmsSummary.vue?vue&type=style&index=0&id=f57b36ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f57b36ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VIcon,VListItem,VListItemAction,VListItemContent,VSheet,VSimpleTable})
